import { type FeatureType } from '@mc-alberta/i18n-data'

export const ACTION_MESSAGE_COMPLETE = 'COMPLETE'
export const ACTION_MESSAGE_READY = 'READY'
export const ACTION_MESSAGE_START = 'START'

export const BETA_FEATURES = [
  {
    description: 'Enable FIDO enrollment and authentication.',
    name: 'AUTHUI_FIDO',
    title: 'Enable FIDO'
  }
]

// TODO: this is the DCF client ID - need one for auth UI
export const CLIENT_ID = 'ce8122ae-88bb-4537-87fe-8e56f9475cb4'

export const DAS_CONSENT = {
  PRIVACY: 'privacy-notices',
  TERMS: 'terms-of-use',
  TERMS_AND_PRIVACY: `terms-of-use-and-privacy-notices`
}

export const ERRORS = {
  ACCT_INACCESSIBLE: 'INACCESSIBLE',
  ACCT_LOCKED: 'ACCT_INACCESSIBLE',
  AUTH_ERROR: 'ERROR',
  AUTHENTICATOR_ALREADY_EXISTS: 'AUTHENTICATOR_ALREADY_EXISTS',
  INTERNAL_FAILURE: 'INTERNAL_FAILURE',
  INVALID_PARAMETER: 'PARAMETER',
  INVALID_REQUEST: 'REQUEST',
  INVALID_STATE: 'STATE',
  ISSUER_DECLINED: 'ISSUER_DECLINED',
  NOT_FOUND: 'FOUND',
  NOT_YOU: 'SWITCH_CONSUMER',
  PERMISSION_DENIED: 'DENIED',
  REGISTRATION_AUTH_ERROR: 'AUTH_ERROR',
  REGISTRATION_FAILED: 'REGISTRATION_FAILED',
  SERVICE_ERROR: 'ERROR',
  SWITCH_CONSUMER: 'SWITCH_CONSUMER',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR'
}

// country-specific features
export const FEATURES: Record<string, FeatureType> = {
  PRECHECK_REMEMBER_ME: 'PRECHECK_REMEMBER_ME'
}

export const KPI_RESOURCE = {
  FIDO_AUTHENTICATION_ERROR_SCREEN: 'FIDO_AUTHENTICATION_ERROR_SCREEN',
  FIDO_AUTHENTICATION_SCREEN: 'FIDO_AUTHENTICATION_SCREEN',
  FIDO_ENROLLMENT_SCREEN: 'FIDO_ENROLLMENT_SCREEN',
  FIDO_REGISTRATION_ERROR_SCREEN: 'FIDO_REGISTRATION_ERROR_SCREEN',
  FIDO_REGISTRATION_SCREEN: 'FIDO_REGISTRATION_SCREEN',
  IDV_AUTHENTICATION_SCREEN: 'IDV_AUTHENTICATION_SCREEN'
}

export const LOCALE = {
  DEFAULT: 'en-US'
}

export const MESSAGE = {
  LOCKED: 'The account exists but is not currently accessible (e.g., is locked).',
  NOT_YOU: 'Not You Button Clicked'
}

export const PRIVACY_URL = 'https://www.mastercard.com/global/passkeys/en-us/privacy-notice.html'

export const ROUTES = {
  BETA: 'Beta',
  CARD_MANAGED_AUTH_INTERSTITIAL: 'CardManagedAuthInterstitial',
  CHALLENGE: 'Challenge',
  CONSUMER_CHALLENGE: 'ConsumerChallenge',
  FIDO_AUTHENTICATION: 'FidoAuthentication',
  FIDO_AUTHENTICATION_ERROR: 'FidoAuthenticationError',
  FIDO_ENROLL: 'FidoEnroll',
  FIDO_ENROLL_ERROR: 'FidoEnrollError',
  HOME: 'Home',
  METHOD_SELECT_MDES: 'MethodSelectMdes',
  PUSH_NOTIFICATION: 'PushNotification',
  VERIFY_MDES: 'VerifyMdes'
}

export const STARK_APP_NAMESPACE = 'authui'

export const TERMS_URL = 'https://www.mastercard.com/global/passkeys/en-us/terms-of-use.html'

export const TEST_OVERRIDES = { ONE_TRUST: 'ONE_TRUST' }

export const TNC_PRIVACY_DEFAULT_LOCALE = 'en-us'
